module.exports = __webpack_public_path__ + "img/once_zh.54faf642.png";